export default {
	showNotification(state) {
		return state.showNotification;
	}
};
